import RequestPasswordChangeRequest from "model/api/RequestPasswordChangeRequest.model";
import { INITIAL_FORGOT_PASSWORD_STATE } from "reducer/auth/ForgotPasswordReducer";
import AuthService from "service/Auth.service"; // Import AuthService
import BaseController from "./BaseController"; // Import BaseController
import { ActionType } from "util/CommonConstant";
import { AxiosResponse } from "axios";
import RequestPasswordChangeResponse from "model/api/RequestPasswordChangeResponse.model";

type IState = typeof INITIAL_FORGOT_PASSWORD_STATE; // Define IState type as typeof INITIAL_LOGIN_STATE

class ForgotPasswordController extends BaseController {
  private state: IState;

  // Constructor for AuthController class
  constructor(state: IState, dispatch: any) {
    super(dispatch); // Call the constructor of the parent class if needed
    this.state = state; // Set the state property to the provided state parameter
  }

  // Method to handle send reset link
  sendResetLink = async () => {
    const payload: RequestPasswordChangeRequest = {
      email: this.state.data.email,
    };

    const res: AxiosResponse<RequestPasswordChangeResponse> =
      await AuthService.requestResetPasswordLink(payload);

    //If the API error
    if (res.status !== 200 && res.status !== 201) {
      const errorMessage = res.data?.response?.error_message ?? "Something went wrong";
      return Promise.reject(new Error(errorMessage));
    }

    this.dispatch({
      type: ActionType.SET_DATA_CHANGE,
      payload: [
        { name: "isResetLinkSent", value: true },
        { name: "toastMessage", value: "Reset link sent successfully. Please check your email." },
      ],
    });

    return res.data;
  };

  // Method to handle to revert isResetLinkSent
  revertIsResetLinkSent = () => {
    this.dispatch({
      type: ActionType.SET_DATA_CHANGE,
      payload: [
        { name: "isResetLinkSent", value: false },
        {
          name: "toastMessage",
          value: "",
        },
      ],
    });
  };
}

export default ForgotPasswordController;
